import { supabase } from '../supabase';

/**
 * Delete a user account
 * @param userId The ID of the user to delete
 * @returns A promise that resolves to a success message or rejects with an error
 */
export async function deleteUserAccount(userId: string): Promise<{ success: boolean; message: string }> {
  try {
    // Call the Supabase Edge Function
    const { data, error } = await supabase.functions.invoke('delete-user', {
      body: { userId },
    });

    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Failed to delete user account:', error);
    throw new Error('アカウント削除に失敗しました。もう一度お試しください。');
  }
}